import React from 'react';
import classes from './style.module.scss';
import Logo from '../../media/logo.svg';
import Telegram from '../../media/telegram.svg';
import Whatsup from '../../media/whats.svg';
import VK from '../../media/vk_logo.svg';
import Instagram from '../../media/instagram.svg';
import Linkify from 'linkify-react';

const NewsItem = ({ news }) => {
    const attachment = news.attachments[0];

    const getNewsItem = () => {
        try {
            if (news.hasOwnProperty('copy_history')) {
                if (news.copy_history[0].attachments[0].type === 'photo') {
                    return (
                        <img
                            src={
                                news.copy_history[0].attachments[0].photo
                                    .sizes[4].url
                            }
                            alt="image"
                        />
                    );
                }
                if (news.copy_history[0].attachments[0].type === 'video') {
                    return (
                        <img
                            src={
                                news.copy_history[0].attachments[0].video
                                    .image[4].url
                            }
                            alt="image"
                        />
                    );
                }
            }

            if (attachment) {
                if (attachment.type === 'photo') {
                    return (
                        <img src={attachment.photo.sizes[4].url} alt="image" />
                    );
                }
                if (attachment.type === 'video') {
                    return (
                        <img src={attachment.video.image[3].url} alt="image" />
                    );
                }
            }

            return <img src={Logo} alt="logo" />;
        } catch (error) {
            return <h2 className={classes.error}>Что-то пошло не так</h2>;
        }
    };

    const getNewsText = () => {
        if (attachment) {
            if (attachment.type === 'video') {
                return attachment.video.description
                    ? attachment.video.description
                    : news.text;
            }
        } else {
            if (news.copy_history) {
                return news.copy_history[0].attachments[0].type === 'video'
                    ? news.copy_history[0].attachments[0].video.description
                        ? news.copy_history[0].attachments[0].video.description
                        : news.copy_history[0].text
                    : news.text;
            }
        }

        return news.text;
    };

    return (
        <div className={classes.container}>
            <div className={classes.newsContainer}>
                <div>
                    <div>{getNewsItem()}</div>
                    {
                        <p className={classes.textContainer}>
                            <Linkify>{getNewsText()}</Linkify>
                        </p>
                    }
                    <div className={classes.social}>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://t.me/legendbogorodskiy"
                        >
                            <img src={Telegram} alt="telegram" />
                        </a>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://chat.whatsapp.com/J30xu9VU7Xq4xpB50yAz0K"
                        >
                            <img src={Whatsup} alt="whatsup" />
                        </a>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://vk.com/legendbogorodskiy"
                        >
                            <img src={VK} alt="vk" />
                        </a>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://instagram.com/legendbogorodskiy?igshid=MzRlODBiNWFlZA=="
                        >
                            <img src={Instagram} alt="instagram" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsItem;
